'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var utils = require('./utils.js');
var styledComponents = require('./styled-components.js');

var RatingBar = function (props) {
    var score = props.score, _a = props.onClick, onClick = _a === void 0 ? function () { return undefined; } : _a, className = props.className;
    var percentage = utils.getPercentage(score);
    var _b = utils.getColorFromScore(score), background = _b.background, foreground = _b.foreground, focus = _b.focus;
    var handleKeyPress = function (e) {
        if (utils.isEnterKey(e.charCode)) {
            e.preventDefault(); // Ensure it is only this code that runs
            onClick();
        }
    };
    return (React__default.createElement(styledComponents.ButtonLikeDiv, { role: 'button', "aria-pressed": 'false', tabIndex: 0, onClick: onClick, onKeyPress: handleKeyPress, className: className, backgroundColor: focus },
        React__default.createElement(styledComponents.ScoreText, { color: background }, score),
        React__default.createElement(styledComponents.BarContainer, null,
            React__default.createElement(styledComponents.BackgroundBar, { backgroundColor: foreground },
                React__default.createElement(styledComponents.ProgressBar, { color: background, percentage: percentage })))));
};

module.exports = RatingBar;
